import { me } from './anon.js';

/** Pages ship anonymous and identical; this fills in who you are. */
const artistLink = document.getElementById('nav-sign');
// The right-hand side of the bar. The mark on the left is in the markup and is
// not ours to touch -- it says the same thing to everyone.
const top = document.getElementById('top');

/**
 * The corner that says who the site thinks you are.
 *
 * Neither state is the usual one. There is no "log in": you are created by your
 * first vu, and coming back is pasting the code you kept, which is a thing that
 * happens on /moi and not in a header. And there is no "sign up" either -- an
 * invitation to make an account would be an invitation to do the one thing this
 * register does not ask of anyone.
 *
 * So signed out says nothing about accounts and just points at the page where
 * arriving, returning and leaving all live. Signed in shows the face and the name, which
 * is the pair a reader recognises, and the way out is one click from there
 * rather than something you have to know to go looking for.
 */
me().then(m => {
  if (artistLink && m.isArtist) artistLink.hidden = false;
  if (!top) return;

  if (!m.name) {
    // The same words the destination uses as its own heading, and the same
    // words the footer link uses. "Reprendre" was neither: it named the one
    // thing on that page a first-time visitor cannot do -- you cannot take
    // back an identity you have never had -- and it was the only way in, so
    // the corner advertised the exception and hid the rule.
    top.innerHTML = '<a href="/moi">Qui vous êtes</a>';
    return;
  }

  // The face is the mark; the name is the label on it. Both link to the same
  // page, because "who am I here" and "stop being me on this machine" are the
  // same question asked from opposite ends.
  const a = document.createElement('a');
  a.className = 'who';
  a.href = '/moi';
  const b = document.createElement('b');
  // textContent, not innerHTML: this is a name the person typed themselves.
  b.textContent = m.name;

  // Only when there is one. The icon's id addresses the face, so no id means no
  // address -- and building `/icons/null` to watch it 404 would be inventing a
  // request we already know the answer to.
  if (m.iconId != null) {
    const img = document.createElement('img');
    // The icon's id, not the person's: the same immutable URL the feed uses, so
    // the corner face is usually already in the browser's cache by the time it
    // is asked for. Nothing about who you are in the URL either.
    img.src = `/icons/${m.iconId}`;
    img.alt = '';
    a.append(img);
  }
  a.append(b);

  // The way out, in the corner, on every page. Someone on a friend's machine
  // realises it while reading the feed, not while already on /moi -- and a
  // control you have to know to go looking for is one they will not find. It
  // links to the code section rather than doing anything itself: forgetting is
  // gated on copying the code, and the gate is there.
  const out = document.createElement('a');
  out.href = '/moi#code';
  out.textContent = 'Oublier';
  out.title = 'Oublier votre code sur cet appareil';

  top.append(a, out);
});

/**
 * Faces that are not there.
 *
 * The icon route 404s rather than serving a default, on purpose: a grey
 * silhouette would be the same mark on everyone who has not chosen one, which
 * is the one thing a mark must not be. A browser answers a 404 with its own
 * broken-image glyph, which is that uniform mark by another route -- so the
 * element is taken out and replaced by a gap of its own width, and the names
 * stay in a column.
 *
 * Here rather than an inline onerror because every page ships this file, and an
 * attribute handler is the kind of thing a future Content-Security-Policy turns
 * off without saying so.
 */
document.querySelectorAll('img.face').forEach(img => {
  img.addEventListener('error', () => {
    const gap = document.createElement('span');
    gap.className = 'noface';
    img.replaceWith(gap);
  });
});
